import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || '/api',
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  async (err) => {
    if (err.response?.status === 401) {
      localStorage.removeItem('token');
      if (!window.location.pathname.startsWith('/login') &&
          !window.location.pathname.startsWith('/registrer') &&
          !window.location.pathname.startsWith('/gi/')) {
        window.location.href = '/login';
      }
    }
    // 423 PERIODE_LAST – tilby overstyring til bruker
    if (err.response?.status === 423 &&
        err.response?.data?.code === 'PERIODE_LAST' &&
        err.response?.data?.kan_overstyres &&
        err.config && !err.config.__tvinget) {
      const melding = (err.response.data.error || 'Perioden er låst.') +
        '\n\nVil du overstyre låsen og bokføre likevel?\n' +
        'Handlingen blir loggført i audit-loggen.';
      // eslint-disable-next-line no-alert
      if (window.confirm(melding)) {
        const cfg = { ...err.config, __tvinget: true };
        try {
          let body = cfg.data;
          if (typeof body === 'string') body = JSON.parse(body);
          body = { ...(body || {}), tving: true };
          cfg.data = JSON.stringify(body);
          cfg.headers = { ...(cfg.headers || {}), 'Content-Type': 'application/json' };
        } catch { /* skipper hvis ikke JSON-body */ }
        return api.request(cfg);
      }
    }
    return Promise.reject(err);
  }
);

export default api;
